module.exports = __webpack_public_path__ + "static/media/14.be709f7.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/14.wav
// module id = tVhr
// module chunks = 0